import { IGroupWithIds } from "../_models/IGroupWithIds";

export function getGroupChildrenRecursively(
    item: IGroupWithIds,
    callback: (child: IGroupWithIds) => void
): void {
    callback(item);
    
    for (const child of item.children) {
        getGroupChildrenRecursively(child, callback);
    }
}